import React, { useState, useEffect } from "react";
import { Box, Button, Container, IconButton, LinearProgress, Typography } from "@mui/material";
import bkstApi from "../../common/component/api";
import moment from "moment";
import currency from "currency.js";
import { useParams } from "react-router-dom";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import { useNavigate } from "react-router";

export default function OrderCharges(props) {
  const navigate = useNavigate();

  const [charges, setCharges] = useState([]);
  const [loading, setLoading] = useState(true);

  const { siteId, orderId } = useParams();

  useEffect(() => {
    bkstApi(`/admin/site/${siteId}/order/${orderId}/charges`).then((res) => {
      setCharges(res.data.charges);
      setLoading(false);
    });
  }, []);

  const sendRefund = () => {
    setLoading(true);
    return bkstApi.post(`/admin/site/:siteId/order/${orderId}/send-refund`, {}).then((res) => {
      navigate(0);
    });
  };

  if (loading) {
    return <LinearProgress />;
  } else {
    const totalCharges = charges.reduce((acc, o) => {
      return acc + o.amount;
    }, 0);
    const totalCaptured = charges.reduce((acc, o) => {
      return acc + o.amount_captured;
    }, 0);
    const totalRefunds = charges.reduce((acc, o) => {
      return acc + o.amount_refunded;
    }, 0);

    return (
      <Container maxWidth="sm">
        <Box mt={5} mb={2} sx={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "space-between" }}>
          <Typography variant="h3">Charges</Typography>
          <Button variant="outlined" onClick={sendRefund}>
            Send Refund
          </Button>
        </Box>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Box p={2} sx={{ backgroundColor: "#ECECEC", flexGrow: 1, textAlign: "center" }}>
            <Typography variant="h5">{currency(totalCharges, { fromCents: true }).format()}</Typography>
            <Typography variant="overline">CHARGES</Typography>
          </Box>
          <Box p={2} sx={{ backgroundColor: "#ECECEC", flexGrow: 1, textAlign: "center" }}>
            <Typography variant="h6">{currency(totalCaptured, { fromCents: true }).format()}</Typography>
            <Typography variant="overline">CAPTURED</Typography>
          </Box>
          <Box p={2} sx={{ backgroundColor: "#ECECEC", flexGrow: 1, textAlign: "center" }}>
            <Typography variant="h6" color="error">
              {currency(totalRefunds, { fromCents: true }).format()}
            </Typography>
            <Typography variant="overline">REFUNDS</Typography>
          </Box>
        </Box>
        {charges.map((o, idx) => (
          <Box p={2} my={3} style={{ backgroundColor: "#FFF" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Box sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
                {o.amount_captured === o.amount ? <CheckCircleOutlinedIcon /> : <WarningAmberOutlinedIcon />}
                <Typography variant="subtitle1">{currency(o.amount, { fromCents: true }).format()}</Typography>
                {+o.amount_refunded > 0 && (
                  <Typography variant="body1" color="error">
                    ({currency(o.amount_refunded, { fromCents: true }).format()})
                  </Typography>
                )}
              </Box>
              <IconButton component="a" target="_blank" href={`https://dashboard.stripe.com/payments/${o.id}`}>
                <LaunchOutlinedIcon />
              </IconButton>
            </Box>
            <Typography variant="overline" color="textSecondary">
              {moment(o.created * 1000).format("LLLL")}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {o.description}
            </Typography>
            <Typography variant="overline" color="textSecondary">
              {o.id}
            </Typography>
          </Box>
        ))}

        <Box my={10}>
          {" "}
          <pre style={{ fontSize: "10px", color: "#FFF", backgroundColor: "#000", textAlign: "left" }}>{JSON.stringify(charges, null, 2)}</pre>
        </Box>
      </Container>
    );
  }
}
